import { css } from '@linaria/core';
import darkTheme from './darkTheme';
import { row } from './row';
import whiteTheme from './whiteTheme';

const root = css`
  ${whiteTheme}
  --selected-color: #fff;
  &.rdg-dark {
    ${darkTheme}
  }

  --color: var(--text-color-primary);
  --border-color: var(--odc-border-color);
  --background-color: var(--background-primary-color);
  --header-background-color: var(--table-header-background-color);
  --row-hover-background-color: var(--table-focus-color);
  --row-selected-background-color: var(--table-hover-color);
  --row-selected-cell-background-color: var(--table-hover-color);
  --row-selected-hover-background-color: var(--table-focus-color);
  --selection-color: #66afe9;
  --font-size: 12px;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
  // We set a stacking context so internal elements don't render on top of external components.
  contain: strict;
  contain: size layout style paint;
  content-visibility: auto;
  height: 350px;
  outline: 1px solid var(--border-color);
  box-sizing: border-box;
  user-select: none;
  background-color: var(--background-color);
  color: var(--color);
  font-size: var(--font-size);

  // set stacking context in safari
  @supports not (contain: strict) {
    position: relative;
    z-index: 0;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
`;

export const rootClassname = `rdg ${root}`;

const focusSink = css`
  position: sticky;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  outline: 0;
`;

export const focusSinkClassname = `rdg-focus-sink ${focusSink}`;

const viewportDragging = css`
  &.${row} {
    cursor: move;
  }
`;

export const viewportDraggingClassname = `rdg-viewport-dragging ${viewportDragging}`;
